/** @deprecated Use SERVICES_PAGE instead */
export const CONVERSION_PAGE = '/conversion';
export const SERVICES_PAGE = '/services';
